import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Button from '../../../../../shared/_TBComponents/Button';

// Shared scaffolding for tag create/edit modals: content wrapper plus the
// Cancel/Save footer. Modal-specific fields are passed in as children.

// The shared Modal's content wrapper is a flex row; without width:100% this child
// shrinks to its intrinsic width and leaves dead space on the right.
export const Body = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 18px;
  width: 100%;
`;

export const FieldLabel = styled.span`
  font-family: "Nunito Sans";
  font-size: 14px;
  font-weight: 700;
  color: #444444;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
`;

const TagModalShell = ({
  children, onCancel, onSave, isSaving, saveDisabled, cancelLabel, saveLabel,
}) => (
  <Body>
    {children}
    <Footer>
      <Button
        name={cancelLabel}
        bgColor='#FFF'
        borderColor='#EEE'
        txtColor='#444444'
        customBorderRadius='4px'
        fontSize='14px'
        styledTextProps={{ fontSize: '14px', fontWeight: 700 }}
        onClick={onCancel}
      />
      <Button
        name={saveLabel}
        bgColor='#444444'
        borderColor='#444444'
        txtColor='#FFF'
        customBorderRadius='4px'
        fontSize='14px'
        isLoading={isSaving}
        disabled={saveDisabled}
        styledTextProps={{ fontSize: '14px', fontWeight: 700 }}
        onClick={onSave}
      />
    </Footer>
  </Body>
);

TagModalShell.propTypes = {
  children: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  cancelLabel: PropTypes.string,
  saveLabel: PropTypes.string,
};

TagModalShell.defaultProps = {
  isSaving: false,
  saveDisabled: false,
  cancelLabel: 'Cancel',
  saveLabel: 'Save',
};

export default TagModalShell;
